// src/LoginPage.tsx
import React, { useState, useEffect } from 'react';
import './login.css'; // Import the CSS file
import MFLogo from '../../assets/sidebarIcons/MFColorlogo.svg';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import LabelText from '../../ui/LabelText';
import LoginErrorIcon from '../../assets/icons/loginError.png';
import MFLoginLogo from '../../assets/images/MF_logo.png';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PrimaryButton from '../../ui/PrimaryButton';
import { useLoading } from '../../contexts/LoadingContext';
import LoadingSpinner from '../../ui/LoadingSpinner';

const LoginPage: React.FC = () => {
    const { login , setIsAuthenticated } = useAuth();
    const navigate = useNavigate();
    const {startLoading , stopLoading , loading} = useLoading();
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [showFlashScreen, setShowFlashScreen] = useState<boolean>(true);
    const [errorMsg , setErrorMsg] = useState<string>('')
    const [showPassword, setShowPassword] = useState(false);
    const [showFadeIn , setShowFadeIn] = useState<boolean>(false)
    
    useEffect(() => {
        const flashTimer = setTimeout(() => setShowFlashScreen(false), 1400);
        const fadeTimer = setTimeout(() => setShowFadeIn(true), 3000);
        const hasValidSession =
            localStorage.getItem("userData") &&
            localStorage.getItem("sessionData") &&
            localStorage.getItem("SessionKey") &&
            localStorage.getItem("sessionStartTime");

        if (hasValidSession) {
            setIsAuthenticated(true);
            navigate("/home");
        }
        return () => {
            clearTimeout(flashTimer);
            clearTimeout(fadeTimer);
        };
    }, [navigate, setIsAuthenticated]);


    const handleLogin = async (event: React.FormEvent) => {
        event.preventDefault();
        try {
            startLoading()
            // const encodedPassword = encodeToBase64(password);
            const data = await login(username, password);
            if (data.success) {
                localStorage.setItem('sessionData', 'currentSession');
                localStorage.setItem('sessionStartTime', new Date().toISOString());
                navigate('/home');
                setUsername('');
                setPassword('');
                stopLoading()
            } else {
                stopLoading()
                setErrorMsg('Invalid username or password.');
            }
        } catch (error) {
            stopLoading()
            console.error('Login error:', error);
            alert('An error occurred. Please try again later.');
        }
    };
    // const encodeToBase64 = (str: string): string => {
    //     return btoa(unescape(encodeURIComponent(str)));
    // };

    return (
        <>
            {showFlashScreen && (
                <div className="flash-screen">
                    <img src={MFLogo} alt="logo" className='logo-animation' width='246px' height='173.969px' />
                </div>
            )}
            {!showFlashScreen && (
                <div className="login-wrapper">
                    <div className={showFadeIn ? 'login' : ''}></div>
                    <div className="login-container">
                        <div className="logo">
                            <img src={MFLoginLogo} alt="mc-football-logo" />
                        </div>
                        <form className="login-form" autoComplete="off">
                            <LabelText className='page-title-text'>Log in</LabelText>
                            <div className="form-group">
                                <LabelText className='custom-list-text'>Email</LabelText>
                                <div className="input-container">
                                <input
                                    type="text"
                                    name="username"
                                    placeholder='Enter your email address'
                                    autoComplete="off"
                                    value={username}
                                    onChange={(e)=>{setUsername(e.target.value)}}
                                />
                                 {username && (
                                    <span className="custom-icon">
                                    <CloseIcon className="icon" onClick={()=>{setUsername('')}} />
                                    </span>
                                )}
                                </div>
                            </div>
                            <div className="form-group">
                                <LabelText className='custom-list-text'>Password</LabelText>
                                <div className="input-container">
                                <input
                                     type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder='Enter your password'
                                    autoComplete="off"
                                    value={password}
                                    onChange={(e)=>{setPassword(e.target.value)}}
                                />
                                {password &&(
                                    <span className="custom-icon" onClick={()=>{setShowPassword(!showPassword)}}>
                                        {showPassword ? <VisibilityIcon/> : <VisibilityOffIcon />}
                                     </span>
                                )}
                                </div>
                                <div style={{display:'flex',alignSelf:'end',cursor:'pointer'}} onClick={()=>{navigate('/forgotpassword')}}><LabelText><a style={{textDecoration:'underline',color:'#54E0C5'}}>Forgot password?</a></LabelText></div>
                            </div>
                           
                        </form>
                        {errorMsg &&(
                            <>
                            <div className='error-container'>
                                <img src={LoginErrorIcon}/>
                                <LabelText className='error-text'>{errorMsg ? errorMsg : ''}</LabelText>
                            </div>
                            </>
                        )}
                        <div>
                            <LabelText>New to Machine Football?</LabelText>
                            <LabelText> <a style={{textDecoration:'underline',color:'#54E0C5'}} onClick={()=>{navigate('/signup')}}> Sign Up</a></LabelText>
                        </div>
                        <LabelText>For any sign-up or login issues, please contact our support team at
                            &nbsp;<a href="mailto:hello@machinefootball.com" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{textDecoration:'underline',color:'#54E0C5'}}
                            >hello@machinefootball.com</a>
                        </LabelText>
                        <div className="form-actions">
                            <PrimaryButton className="login-button"
                                onClick={handleLogin} label="Log in"
                                disabled={username === '' || password === ''}
                            />
                        </div>
                    </div>
                    </div>
                
            )}
            {loading && (<LoadingSpinner/>)}
        </>
    );
};

export default LoginPage;
